/* eslint-disable no-undef */
export default class ShopifyCart {
  constructor() {
    // Config iniettata da DefinePlugin
    this.domain = __SHOPIFY_DOMAIN__;
    this.token = __SHOPIFY_TOKEN__;
    this.apiVersion = __SHOPIFY_API_VERSION__;

    this.cartContainerId = "global-cart-container";
    this.toggleContainerId = "global-cart-toggle";
    this.productContainerId = "product-container";

    this.client = null;
    this.ui = null;
    this.cartInstance = null;
    this.toggleCreated = false;

    this.init();
  }

  init() {
    const scriptURL =
      "https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js";

    if (window.ShopifyBuy && window.ShopifyBuy.UI) {
      this.initShopify();
    } else {
      const script = document.createElement("script");
      script.src = scriptURL;
      script.async = true;
      script.onload = () => this.initShopify();
      document.head.appendChild(script);
    }
  }
  initShopify() {
    this.client = ShopifyBuy.buildClient({
      domain: this.domain,
      storefrontAccessToken: this.token,
    });

    //const checkoutId = this.getCheckoutId();

    ShopifyBuy.UI.onReady(this.client)
      .then((ui) => {
        console.log("✅ Shopify UI pronta");
        this.ui = ui;

        // 🔍 Controllo della valuta del negozio
        this.checkStoreCurrency();
        // 🛒 Crea carrello globale
        this.createGlobalCart();

        // 🛍️ Crea Buy Button se in pagina prodotto
        this.createProductButton();
      })
      .catch((err) => {
        console.error("❌ Errore ShopifyBuy.UI.onReady:", err);
      });
  }

  // 🔍 NUOVA FUNZIONE: verifica valuta del tuo store Shopify
  checkStoreCurrency() {
    this.client.checkout.create().then((checkout) => {
      console.log("🌍 Valuta del negozio:", checkout.currencyCode);
      // Puoi anche salvarla internamente se ti serve:
      this.storeCurrency = checkout.currencyCode;
    });
  }

  createGlobalCart() {
    const cartNode = document.getElementById(this.cartContainerId);
    const toggleNode = document.getElementById(this.toggleContainerId);

    if (!cartNode) {
      console.warn("⚠️ Nessun nodo carrello trovato");
      return;
    }

    try {
      this.cartInstance = this.ui.createComponent("cart", {
        node: cartNode,
        toggles: toggleNode ? [{ node: toggleNode }] : [],
        moneyFormat: "€ {{amount}}", // niente codifica URL
        options: {
          cart: {
            popup: false,
            startOpen: false,
            //iframe: false, //se vogliamo gestire noi completamente la grafica
            styles: { cart: { zIndex: 999999 } },
            text: {
              title: "Il tuo carrello",
              total: "Totale",
              empty: "Il carrello è vuoto",
              notice: "Spedizione e tasse calcolate al checkout",
              button: "Procedi al checkout",
            },
          },
          toggle: {
            sticky: false,
            iframe: false,
            contents: {
              icon: true,
              count: false,
            },
          },
        },
      });
      console.log("🛒 Carrello globale creato");
    } catch (e) {
      console.error("❌ Errore creazione carrello:", e);
    }
  }

  createProductButton() {
    const productNode = document.getElementById(this.productContainerId);
    if (!productNode) return;

    const productId = productNode.dataset.productId; //|| "7997469294628"
    const toggleNode = document.getElementById(this.toggleContainerId);
    console.log(productNode.dataset);
    try {
      this.ui.createComponent("product", {
        id: productId,
        node: productNode,
        moneyFormat: "{{amount}} € ", // niente codifica URL
        toggles: toggleNode ? [{ node: toggleNode }] : [],
        options: {
          product: {
            iframe: false,
            /*moneyFormat: "€{{amount}}", // ora funziona*/
            buttonDestination: "cart",
            buttonWithQuantity: true,
            contents: {
              title: false,
              price: true,
              img: false,
              button: true,
              quantity: true, // button to increase quantity
              quantityIncrement: true, // button to increase quantity
              quantityDecrement: true, // button to decrease quantity
            },
            text: {
              button: "Aggiungi al carrello",
              outOfStock: "Esaurito",
              // eventuali altre chiavi supportate dal Buy Button
            },
            styles: {
              price: {
                //color: "red",
              },
            },
          },
          /*toggle: {
            sticky: false,
            iframe: false,
            contents: {
              count: true,
              icon: false,
            },
          },*/
        },
      });
      console.log("🛍️ Prodotto creato per ID:", productId);

      // 🏷️ Badge percentuale di sconto (il Buy Button mostra già prezzo pieno/scontato, non la %)
      this.observeDiscountBadge(productNode);
    } catch (e) {
      console.error("❌ Errore creazione product component:", e);
    }
  }

  // Converte un testo prezzo (es. "1.234,56 €" o "1234.56") in numero
  parseMoney(text) {
    if (!text) return NaN;
    let cleaned = text.replace(/[^0-9.,]/g, "");
    const lastComma = cleaned.lastIndexOf(",");
    const lastDot = cleaned.lastIndexOf(".");
    if (lastComma > lastDot) {
      cleaned = cleaned.replace(/\./g, "").replace(",", ".");
    } else {
      cleaned = cleaned.replace(/,/g, "");
    }
    return parseFloat(cleaned);
  }

  // Legge prezzo pieno/scontato già renderizzati dal Buy Button e mostra la % di sconto
  updateDiscountBadge(productNode) {
    const priceWrap = productNode.querySelector(".shopify-buy__product__price");
    if (!priceWrap) return;

    const actualEl = priceWrap.querySelector(".shopify-buy__product__actual-price");
    const compareEl = priceWrap.querySelector(".shopify-buy__product__compare-price");
    let badge = priceWrap.querySelector(".shopify-buy__product__discount-percent");

    const compareText = compareEl ? compareEl.textContent.trim() : "";
    if (!actualEl || !compareText) {
      if (badge) badge.remove();
      return;
    }

    const actual = this.parseMoney(actualEl.textContent);
    const compare = this.parseMoney(compareText);
    if (!actual || !compare || compare <= actual) {
      if (badge) badge.remove();
      return;
    }

    const percent = Math.round((1 - actual / compare) * 100);
    const newText = `-${percent}%`;

    // Evita di scrivere se il valore non è cambiato: altrimenti la scrittura
    // genera una mutazione che rifà scattare il MutationObserver all'infinito.
    if (badge && badge.textContent === newText) return;

    if (!badge) {
      badge = document.createElement("span");
      badge.className = "shopify-buy__product__discount-percent";
      priceWrap.appendChild(badge);
    }
    badge.textContent = newText;
  }

  // Osserva il container del Buy Button per aggiornare il badge quando il prezzo cambia (es. cambio variante)
  observeDiscountBadge(productNode) {
    const observer = new MutationObserver(() => this.updateDiscountBadge(productNode));
    observer.observe(productNode, { childList: true, subtree: true, characterData: true });
    this.updateDiscountBadge(productNode);
  }
} //fine classe
